// https://react-typescript-cheatsheet.netlify.app/docs/basic/getting-started/error_boundaries/
import React, { Component, ErrorInfo, ReactNode } from 'react';
import 'src/components/Errors/ErrorBoundary.scss';
import alertIcon from 'src/images/preview_unavailable_icon.svg';

const dictionary: Record<string, string> = {
  'de-at': 'Vorschau nicht verfügbar',
  'de-ch': 'Vorschau nicht verfügbar',
  'de-de': 'Vorschau nicht verfügbar',
  'en-gb': 'Preview unavailable',
  'en-ie': 'Preview unavailable',
  'es-es': 'Vista previa no disponible',
  'fr-be': 'Aperçu non disponible',
  'fr-ch': 'Aperçu non disponible',
  'fr-fr': 'Aperçu non disponible',
  'it-ch': 'Anteprima non disponibile',
  'it-it': 'Anteprima non disponibile',
  'nl-be': 'Preview niet beschikbaar',
  'nl-nl': 'Preview niet beschikbaar',
  'pt-pt': 'Pré-visualização indisponível',
  'sv-se': 'Förhandsvisning är inte tillgänglig',
};

interface Props {
  children: ReactNode;
  locale: string | undefined;
}

interface State {
  hasError: boolean;
}
class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      const locale: string = this.props.locale?.toLowerCase() ?? 'en-gb';
      const message = dictionary[locale];
      return (
        <div className="error-message">
          <img src={alertIcon} alt="error message icon" />
          <p>{message}</p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
